import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import { createFileRoute } from '@tanstack/react-router'
import { ActivitySessionFeed } from '~/components/admin/activity-session-feed'
import { PageHeader } from '~/components/ui/page-header'
import { titleFor } from '~/lib/route-title'

export const Route = createFileRoute('/admin/activity')({
  component: AdminActivity,
  head: () => ({ meta: [{ title: titleFor(msg`Activity`) }] }),
})

function AdminActivity() {
  const { t } = useLingui()
  return (
    <div className="flex h-full flex-col">
      <PageHeader
        meta={t`Every write across all workspaces, grouped into sessions`}
        title={t`Activity`}
      />
      <div className="min-h-0 flex-1 overflow-y-auto px-5 pb-6">
        <ActivitySessionFeed scope={{ kind: 'global' }} />
      </div>
    </div>
  )
}
